<template>
    <b-modal
        v-model="mostrarModalMeta"
        @show="obterTiposInstrumento()"
        @hide="fecharModal()"
        @close="fecharModal()"
        no-enforce-focus>
        <div slot="modal-title">
            Meta -
            <b-badge variant="warning">{{ operacaoProp }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="5">
                <b-form-group>
                    <label class="required">Tipos de Instrumento</label>
                    <b-input-group>
                        <b-form-select
                            type="text"
                            :options="tiposInstrumento"
                            text-field="descCategoria"
                            value-field="codCategoria"
                            v-model="codCategoria"
                            >
                        </b-form-select>
                        <b-form-invalid-feedback>O Tipo de Instrumento da meta é obrigatório.</b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="6" >
                <b-form-group>
                    <label class="required">Meta de Empresas Atendidas</label>
                    <b-input-group>
                        <b-form-input
                        v-mask="'########'"
                            type="number"
                            v-model="metaEmprAtendidas"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="6">
                <b-form-group>
                    <label class="required">Meta de Pessoas Atendidas</label>
                    <b-input-group>
                        <b-form-input
                        v-mask="'########'"
                            type="number"
                            v-model="metaPesAtendidas"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="6">
                <b-form-group>
                    <label class="required">Cargo Horária</label>
                    <b-input-group>
                        <b-form-input
                            v-mask="'########'"
                            type="number"
                            v-model="cargoHoraria"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        evento: {
            type: Object,
            default: () => {}
        },

        erros: {
            type: Array,
            default: () => []
        },

        dataServicos: {
            type: Object
        },
    },

    validations: {
        codCategoria: {
            required
        },
        // quantidade: {
        //     required,
        //     minValue: minValue(0.1)
        // }
    },

    data() {
        return {
            mostrarModalMeta: false,
            codCategoria: null,
            tiposInstrumento: [],
            metaPesAtendidas:null,
            metaEmprAtendidas:null,
            cargoHoraria:null,
            operacaoProp: 'INSERÇÃO'
        }
    },

    methods: {
        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar() {
            this.mostrarModalMeta = false
            this.metaEmprAtendidas = null,
            this.metaPesAtendidas = null,
            this.cargoHoraria = null,
            this.tiposInstrumento = []
            this.codCategoria = null
        },

        obterTiposInstrumento() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterTiposInstrumento().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.tiposInstrumento = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        salvar(){
            this.$store.dispatch('addRequest')

            let metaDto = {
                tipoInstrumento : this.codCategoria,
                metaEmprAtendidas : this.metaEmprAtendidas,
                metaPesAtendidas : this.metaPesAtendidas,
                cargoHoraria : this.cargoHoraria,
                idEvento : this.evento.idEvento

            }
            this.dataServicos.inserirMeta(metaDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Meta inserida com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.$emit('atualizarErros', response.errors);
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    },

    watch: {
        mostrarModal() {
            this.mostrarModalMeta = this.mostrarModal
        },
    },
}
</script>
